import { render, staticRenderFns } from "./SyncQuotasDialog.vue?vue&type=template&id=2588bdb1&"
import script from "./SyncQuotasDialog.vue?vue&type=script&lang=ts&"
export * from "./SyncQuotasDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports